import { useTranslation } from "react-i18next";
import i18n from "src/i18n";
import { Section, SettingRow } from "./SettingsControls";

const LANGUAGES = [
    { code: "en", label: "English" },
    { code: "de", label: "Deutsch" },
];

export function LanguageSettings() {
    const { t } = useTranslation();
    const current = i18n.language;

    const change = (code: string) => {
        i18n.changeLanguage(code);
        localStorage.setItem("lang", code);
    };

    return (
        <Section title={t("language.title")}>
            <SettingRow
                title={t("language.title")}
                description={t("language.description")}
            >
                <div className="toggle-group">
                    {LANGUAGES.map((lang) => (
                        <button
                            key={lang.code}
                            className={`toggle-btn${current === lang.code ? " toggle-btn--active" : ""}`}
                            onClick={() => change(lang.code)}
                        >
                            {lang.label}
                        </button>
                    ))}
                </div>
            </SettingRow>
        </Section>
    );
}
